import i18n from "../i18n/i18n";
import {DateUtils} from "./dateUtils";

export class Utils {
    public static range(min: any, max: any) {
        return [...Array(max - min + 1).keys()].map(i => i + min);
    }

    public static upperCaseFirstLetter(message: string) {
        if (!message) {
            return "";
        }
        return `${message[0].toUpperCase()}${message.substring(1)}`;
    }

    public static scrollToFirstErrorMessage() {
        window.setTimeout(() => {
            const firstErrorMessage = document.getElementsByClassName("notification-with-error")[0] || document.getElementsByClassName("error-message")[0];

            if (firstErrorMessage) {
                firstErrorMessage.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 0);
    }

    public static scrollToElement(id: string) {
        window.setTimeout(() => {
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView({
                    inline: "center",
                    block: "center"
                });
            }
        }, 100);
    }

    public static scrollToFirstClass(className: string) {
        window.setTimeout(() => {
            const element = document.getElementsByClassName(className);

            if (element && element.length) {
                element[0].scrollIntoView({ block: "center"});
            }
        }, 0);
    }

    public static renderBooleanValueInFile(value: boolean | undefined) {
        return value ? "X" : "";
    }

    public static renderTime(time: any) {
        return time ? DateUtils.getFormattedDateWithTime(new Date(time)) : null;
    }

    public static renderBooleanYesNoValue(value: boolean | null | undefined, isDash: boolean) {
        if (value === null || value === undefined) {
            return isDash ? "-" : "";
        }

        return value ? i18n.t("yes") : i18n.t("no");
    }

    public static calculateWidthOnTable() {
        const largeMenuWidth = 280;
        const smallMenuWidth = 80;
        const switchWrapperMargins = 44; // margin left + margin right in app
        const smallErrorThreshold = 2; // error threshold for extra large screen
        const largeErrorThreshold = 8; // error threshold for normal and mobile screen
        const widthMobileScreen = 900;
        const widthFullHdScreen = 1920;

        let calcWidth;
        if (window.innerWidth > widthMobileScreen) {
            if (window.innerWidth >= widthFullHdScreen) { // extra large
                calcWidth = window.innerWidth - (largeMenuWidth + switchWrapperMargins + smallErrorThreshold);
            } else { // normal desktop + laptops
                calcWidth = window.innerWidth - (largeMenuWidth + switchWrapperMargins + largeErrorThreshold);
            }
        } else { // small screen + tablets + mobile
            calcWidth = window.innerWidth - (smallMenuWidth + switchWrapperMargins + largeErrorThreshold);
        }
        return calcWidth;
    }

    public static changeCommaToDot(value: string | number | null): string | number | null {
        if (typeof value === "string") {
            return value.replace(",", ".");
        } else {
            return value;
        }
    }

    public static changeDotToComma(value: string | number | null): string | number | null {
        if (value || value === 0 || value === "0") {
            let valueToChange = "";
            if (typeof value === "string") {
                valueToChange = value;
            } else {
                if (value || value === 0) {
                    valueToChange = value.toString();
                }
            }

            return valueToChange.replace(".", ",");
        } else {
            return value;
        }
    }

    public static wrapText(text: string, weight: number, separator: string) {
        if (!text) return "";

        let result = "";

        if (text.length > weight) {
            result = text.substring(0, weight) + separator + "\n" + this.wrapText(text.substring(weight, text.length), weight, separator);
        } else {
            result = text;
        }

        return result;
    }

    public static renderValueWithUnit(value: number | string | null, unit: string): string {
        const fieldValue = (typeof value === "number") ? value.toString() : value;

        return fieldValue ? (unit ? `${fieldValue} ${unit}` : `${fieldValue}`) : "";
    }

    public static convertToNumberOrNull(value: number | string | null | undefined): number | null {
        return value === 0 ? 0 : value ? Number(value) : null;
    }

    public static convertNullAndUndefinedToEmptyString(value: number | string | null | undefined): string | number {
        return value === null ? "" :(value === undefined ? "" : value);
    }

    public static isTabletOrMobile(): boolean {
        if (
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        }

        return false;
    }

    public static changePriceFormatByLanguage(price: string | number | null, language: string): string {
        if (price || price === 0 || price === "0") {
            if (language === "pl") {
                return this.changeDotToComma(price)!.toString();
            } else {
                return this.changeCommaToDot(price)!.toString();
            }
        } else {
            return "";
        }
    }
}